/*
   Copyright (c) 2019-2020 Designble. All rights reserved.
   Any unauthorized usage will be subject to legal action.
*/

function displayNavBar() {
  var x = document.getElementById("collapsenavbar");
  if (x.style.display === "") {
    x.style.display = "flex";
  } else {
    x.style.display = "";
  }
}